import { observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import IconButton from 'src/view/components/Controls/IconButton/IconButton';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';
import { IRoute } from '../MenuList/MenuList';

@observer
class HamburgerMenuItem extends React.Component<IRoute> {
  private getTitle() {
    if (typeof this.props.text !== 'string') {
      return this.props.title || '';
    }

    return this.props.text;
  }

  public render() {
    return (
      <NavLink
        target={this.props.target}
        hrefLang={localeStore.language}
        title={this.getTitle()}
        rel="bookmark"
        to={{
          pathname: this.props.to,
          search: `?language=${localeStore.language}`,
        }}
        className="hamburger-menu-item background_hover-secondary th-bg-background_hover-secondary"
        activeClassName={'hamburger-menu-item_active'}
      >
        {this.props.icon ? (
          <IconButton iconClassName={'th-background-secondary th-selected_hover-primary'} name={this.props.icon} />
        ) : null}
        <p className={`th-color-primary d-flex flex-grow-1 ${this.props.icon ? 'ml-1' : 'ml-3'}`}>{this.props.text}</p>
      </NavLink>
    );
  }
}

export default HamburgerMenuItem;
